function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4762 12.1379L46.9053 9.98762L43.149 9.50663L52.5398 4.92308L40.2897 3.31034L32.6088 13.0433L26.5538 0L20.4708 13.0433L12.7899 3.31034L0.539795 4.92308L9.93063 9.50663L6.20233 9.98762L10.6314 12.1379L4.82874 12.9019L17.6395 19.1547L11.6686 32H41.411L35.4401 19.1547L48.2789 12.9019L42.4762 12.1379ZM35.4681 13.2414L33.7301 15.4483L33.2255 14.3448L35.4681 13.2414ZM19.8821 14.3448L19.3775 15.4483L17.6395 13.2414L19.8821 14.3448ZM14.584 14.0619L18.9851 16.2122L18.0039 18.3908L14.584 14.0619ZM35.7204 28.718H33.1134L30.9549 23.71H22.349L20.1624 28.718H17.4994L25.2083 11.6004H28.1236L35.7204 28.718ZM35.1037 18.3908L34.0945 16.2122L38.4956 14.0619L35.1037 18.3908Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2547 15.0522C27.0585 14.5429 26.8343 13.977 26.638 13.3546C26.4979 13.8072 26.3016 14.3165 26.1054 14.8541C25.9092 15.42 25.713 15.901 25.5167 16.3254L23.106 21.8992H30.1701L27.7313 16.2405C27.6192 15.9576 27.451 15.5614 27.2547 15.0522Z",
  fill: "white"
});

function SvgAngelLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 32,
    viewBox: "0 0 53 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngelLogoFooter);
export default __webpack_public_path__ + "static/media/angel-logo-footer.f9525e84.svg";
export { ForwardRef as ReactComponent };